var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C7.50877 16 7.12281 15.614 7.12281 15.1228C7.12281 11.6842 4.31579 8.87719 0.877193 8.87719C0.385965 8.87719 0 8.49123 0 8C0 7.50877 0.385965 7.12281 0.877193 7.12281C4.31579 7.12281 7.12281 4.31579 7.12281 0.877193C7.12281 0.385965 7.50877 0 8 0C8.49123 0 8.87719 0.385965 8.87719 0.877193C8.87719 4.31579 11.6842 7.12281 15.1228 7.12281C15.614 7.12281 16 7.50877 16 8C16 8.49123 15.614 8.87719 15.1228 8.87719C11.6842 8.87719 8.87719 11.6842 8.87719 15.1228C8.87719 15.614 8.49123 16 8 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStar);
export default __webpack_public_path__ + "static/media/ic_star.2e5ef16fb8d3f68a0c070f9e7b28ffff.svg";
export { ForwardRef as ReactComponent };